import React from 'react';
import { useLanguage } from '../../context/LanguageContext';

const WhyUsSection = () => {
  const { t } = useLanguage();
  return (
    <section className="section-padding bg-white"><div className="container-custom"><h2 className="text-3xl sm:text-4xl font-display font-bold text-night mb-4">{t('whyUs.title')}</h2><p className="text-gray-600 text-lg">{t('whyUs.subtitle')}</p></div></section>
  );
};

export default WhyUsSection;
